import React from "react"

export default function SearchInputWrapper({
  value,
  onChange,
  placeholder = "Search...",
  onClear,
  style = {},
  wrapperWidth = "100%",
}) {
  return (
    <div className="search-input-wrapper" style={{ width: wrapperWidth }}>
      <input
        type="text"
        className="search-input-box"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={style}
      />

      {value && (
        <button
          className="clear-btn"
          type="button"
          aria-label="Clear search"
          onClick={() => onClear?.()}
        >
          ×
        </button>
      )}
    </div>
  )
}
